import VueCookie from 'vue-cookie';
import { get } from 'lodash/object';
import * as pumaConsts from '@/const/puma';
import store from '@/store/store';
import { checkToken, logOff } from '@/api/auth';
import { cleanUrl } from '../components/Login/mixin/helper';

// 只判断是否满足 uuid 格式
export function isValidAccessToken(accessToken = '') {
    // eslint-disable-next-line no-useless-escape
    return /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/.test(
        accessToken);
}

export function getCookie() {
    return VueCookie.get(pumaConsts.TOKEN_COOKIE_NAME);
}

export function isValidLoggedCookie(cookieStr = '') {
    if (!cookieStr) {
        return false;
    }

    let cookieStrURIDecoded;
    try {
        cookieStrURIDecoded = decodeURIComponent(cookieStr);
    } catch (e) {
        console.error(e);
        return false;
    }

    let cookie;
    try {
        cookie = JSON.parse(cookieStrURIDecoded);
    } catch (e) {
        console.error(`json 解析失败: ${cookieStrURIDecoded}`);
        return false;
    }

    const accessToken = get(cookie, 'accessToken', '');
    return isValidAccessToken(accessToken);
}

export function isLoggedIn() {
    const cookieStr = getCookie();
    return isValidLoggedCookie(cookieStr);
}

export async function isLoggedInAsync() {
    if (!isLoggedIn()) {
        return false;
    }

    let res;
    try {
        res = await checkToken();
    } catch (e) {
        console.error(e);
        return false;
    }
    return res;
}

// TODO 放到 helper 仓库中
export function parseCookieStr(cookieStr = '') {
    if (!cookieStr) {
        throw new Error('从 cookie 中解析 token 信息失败, cookie 为空');
    }

    let cookieStrURIDecoded;
    try {
        cookieStrURIDecoded = decodeURIComponent(cookieStr);
    } catch (e) {
        console.error(e);
        throw new Error(
            '从 cookie 中解析 token 信息失败，decodeURIComponent 失败');
    }

    let cookie;
    try {
        cookie = JSON.parse(cookieStrURIDecoded);
    } catch (e) {
        console.error(e);
        throw new Error('从 cookie 中解析 token 信息失败，JSON.parse 失败');
    }

    return cookie;
}

export function getTokenObj() {
    const cookieStr = getCookie();
    return parseCookieStr(cookieStr);
}

// 返回指定域名的二级域名（如果存在）
// 这里的"二级域名"定义和维基百科中的略有不同
// 比如输入 "mail.google.com" 则会输出 "google.com"
export function get2LDByHostname(hostname = '') {
    if (!hostname) {
        return '';
    }
    try {
        let names = hostname.split('.');
        if (names.length === 1) {
            return hostname;
        } else {
            return names.slice(-2).join('.');
        }
    } catch (e) {
        console.error(e);
        return '';
    }
}

export function get2LD() {
    return get2LDByHostname(window.location.hostname);
}

// logout 后续逻辑处理
// FIXME 改成 postLogout 似乎更加合适
export async function logout() {
    VueCookie.delete(pumaConsts.TOKEN_COOKIE_NAME, {
        domain: get2LD()
    });
    sessionStorage.clear();
    return store.dispatch('reset');
}

// 用户触发
export async function handleLogout() {
    try {
        await logOff();
    } catch (e) {
        console.log(e);
    } finally {
        await logout();
        cleanUrl();
        window.location.reload();
    }
}
